export default __webpack_public_path__ + "static/media/TicTac-Learn-Website-Ver-1-09-3.1cad1802.jpg";